var _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a66a61db-fbcd-42ce-a372-2e56072a59df",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69 56.5",
    style: {
      enableBackground: "new 0 0 255.6 56.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "scLogo001",
    gradientUnits: "userSpaceOnUse",
    x1: 23.0842,
    y1: 3005.927,
    x2: 60.6747,
    y2: 2948.4167,
    gradientTransform: "matrix(1 0 0 1 0 -2946.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c798"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#177ef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2665d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#8d1ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ff4083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff5e5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fdb200"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#scLogo001)"
    },
    d: "M68.2,51.6L40.9,2.2c-2-3-6.7-3-8.7,0l-6.8,10.9c-0.4,0-0.8-0.1-1.2-0.1 c-6.2,0-11.4,3.4-13.5,8.5C4.7,21.9,0,27,0,33.4C0,38,2.6,42,6.4,44l-4.7,7.5c-1.4,2.2,0.2,4.9,2.8,4.9h60.9 C68,56.5,69.6,53.8,68.2,51.6C68.2,51.6,68.2,51.6,68.2,51.6z M11.5,26.2c0.7,0,1.4,0.1,2,0.4c0,0,0.1,0.1,0.4,0.1 c0.3,0,0.6-0.1,0.6-0.6c0.2-4.6,3.9-7.6,8-8.3c0.6-0.1,1.1-0.1,1.7-0.1c6,0,10.8,4.8,10,10.9c-0.1,1.4-0.4,1.8-0.7,2.5 c-0.2,0.5,0.2,0.7,0.4,0.7l0,0c3.3,0,4.7,2.4,4.7,4.7c0,2.3-1.5,4.2-4.1,4.2H11.8c-1,0-2-0.2-2.9-0.7c-2.5-1.1-4.2-3.7-4.2-6.7 C4.7,29.4,7.5,26.2,11.5,26.2C11.5,26.2,11.5,26.2,11.5,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M11.5,26.2c0.7,0,1.4,0.1,2,0.4c0,0,0.1,0.1,0.4,0.1c0.3,0,0.6-0.1,0.6-0.6c0.2-4.6,3.9-7.6,8-8.3 c0.6-0.1,1.1-0.1,1.7-0.1c6,0,10.8,4.8,10,10.9c-0.1,1.4-0.4,1.8-0.7,2.5c-0.2,0.5,0.2,0.7,0.4,0.7l0,0c3.3,0,4.7,2.4,4.7,4.7 c0,2.3-1.5,4.2-4.1,4.2H11.8c-1,0-2-0.2-2.9-0.7c-2.5-1.1-4.2-3.7-4.2-6.7C4.7,29.4,7.5,26.2,11.5,26.2 C11.5,26.2,11.5,26.2,11.5,26.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.1.2.1.svg";
export { ForwardRef as ReactComponent };